module.exports = __webpack_public_path__ + "img/publicCredit.e0d2ddc0.png";